import { render, staticRenderFns } from "./printPayFeeXinShiDai.vue?vue&type=template&id=3b209854&scoped=true"
import script from "./printPayFeeXinShiDai.vue?vue&type=script&lang=js"
export * from "./printPayFeeXinShiDai.vue?vue&type=script&lang=js"
import style0 from "./printPayFeeXinShiDai.vue?vue&type=style&index=0&id=3b209854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b209854",
  null
  
)

export default component.exports